import React from 'react';
import { Layout } from '../components/Layout';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import { MapPin, Calendar, MessageCircle, Phone } from 'lucide-react';
import { Button } from '../components/ui/Button';
const BOOKING_URL = 'https://denticoclinic.patientportal.onl/bookings';
const WHATSAPP_URL = 'https://wa.me/447345197820';
export function SitemapPage() {
  const {
    lang
  } = useTranslation();
  return <Layout data-id="element-4088" data-mp="2yddzsq3utt4y">
      <section className="py-16 bg-white" data-id="element-4089" data-mp="2yh1sxo5e0dj5">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4090" data-mp="2uedhd8pagsih">
          <h1 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-4091" data-mp="38dd5mf8w35e4">
            Dentico Clinic Sitemap
          </h1>
          <p className="text-lg text-gray-600 mb-12" data-id="element-4092" data-mp="33ejugth2rqh4">
            Welcome to Dentico Clinic, Private Dental Clinic in Angel, London
            EC1V.
          </p>

          <div className="space-y-10" data-id="element-4093" data-mp="1e1gbufmz5nfw">
            {/* Main Pages */}
            <div data-id="element-4094" data-mp="191kfn2kir0aw">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4095" data-mp="1923ntrkdaabq">
                Main Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-4096" data-mp="3odjm8fnkkgzc">
                <li data-id="element-4097" data-mp="3oel2cyjfztnx">
                  <Link to={`/${lang}`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4098" data-mp="3obp1b1casov9">
                    Home – Private Dentist in Angel, London
                  </Link>
                </li>
                <li data-id="element-4099" data-mp="5ztz9mb8wyqi">
                  <Link to={`/${lang}/about`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4100" data-mp="az6izy6tlpov">
                    About Us – Meet Our Dental Team
                  </Link>
                </li>
                <li data-id="element-4101" data-mp="jxquofdyqz3l">
                  <Link to={`/${lang}/contact`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4102" data-mp="2hpmj7fyyupfp">
                    Contact – Book Appointment
                  </Link>
                </li>
              </ul>
            </div>

            {/* Language Versions */}
            <div data-id="element-4103" data-mp="3k4ln9jxxpyls">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4104" data-mp="3k557x8eyz13i">
                Language Versions
              </h2>
              <ul className="space-y-2.5" data-id="element-4105" data-mp="3u0yqp9ja7qtq">
                <li data-id="element-4106" data-mp="3u3b7vkh7tx5q">
                  <Link to="/en" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4107" data-mp="bvlshscz4rje">
                    🇬🇧 English Version
                  </Link>
                </li>
                <li data-id="element-4108" data-mp="lkvkl87tia7i">
                  <Link to="/ua" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4109" data-mp="lnhomxvi27kz">
                    🇺🇦 Ukrainian Version
                  </Link>
                </li>
                <li data-id="element-4110" data-mp="po1qger0pzdg">
                  <Link to="/ru" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4111" data-mp="potjpix57l0k">
                    🇷🇺 Russian Version
                  </Link>
                </li>
              </ul>
            </div>

            {/* Dental Services */}
            <div data-id="element-4112" data-mp="149p9fwlhixuq">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4113" data-mp="1496197lmzntw">
                Dental Services
              </h2>
              <ul className="space-y-2.5" data-id="element-4114" data-mp="qgzntt9vbuy5">
                <li data-id="element-4115" data-mp="v8r67giveud7">
                  <Link to={`/${lang}/services`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4116" data-mp="va2hs2ik56ev">
                    All Services
                  </Link>
                </li>
                <li data-id="element-4117" data-mp="7jons6gewxhn">
                  <Link to={`/${lang}/prices#consultations`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4118" data-mp="7j6heh01d2w0">
                    Dental Examinations & Consultations
                  </Link>
                </li>
                <li data-id="element-4119" data-mp="3vnv1rjl279xb">
                  <Link to={`/${lang}/services/hygiene`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4120" data-mp="3vpfynfuuj4yc">
                    Professional Hygiene & Airflow
                  </Link>
                </li>
                <li data-id="element-4121" data-mp="3hxj8hhcqn54l">
                  <Link to={`/${lang}/services/fillings`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4122" data-mp="3hy1db2dguro4">
                    White Fillings
                  </Link>
                </li>
                <li data-id="element-4123" data-mp="33ya1n8af9nda">
                  <Link to={`/${lang}/services/root-canal`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4124" data-mp="33yrzg9cqg9nb">
                    Root Canal Treatment
                  </Link>
                </li>
                <li data-id="element-4125" data-mp="2k2p95luqoxht">
                  <Link to={`/${lang}/services/crowns`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4126" data-mp="2k14c9pkyd2gs">
                    Crowns & Bridges
                  </Link>
                </li>
                <li data-id="element-4127" data-mp="2xu3vo2nuvgtm">
                  <Link to={`/${lang}/services/smile-makeover`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4128" data-mp="2xwg8y2io530c">
                    Veneers & Smile Makeover
                  </Link>
                </li>
                <li data-id="element-4129" data-mp="2a75ibdv18ozx">
                  <Link to={`/${lang}/services/extraction`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4130" data-mp="2f445tdk6xxp5">
                    Tooth Extraction
                  </Link>
                </li>
                <li data-id="element-4131" data-mp="3ql402eq3mmlt">
                  <Link to={`/${lang}/services/whitening`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4132" data-mp="1qgrqbfc7lcky">
                    Teeth Whitening
                  </Link>
                </li>
                <li data-id="element-4133" data-mp="20cv0n8h7shiz">
                  <Link to={`/${lang}/services/cosmetic`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4134" data-mp="1vge53t7or0vv">
                    Cosmetic Treatments
                  </Link>
                </li>
              </ul>
            </div>

            {/* Specialist Pages (UA) */}
            <div data-id="element-4135" data-mp="1hig1niuwkov5">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4136" data-mp="1cpmwwuzfpgj2">
                Specialist Pages
              </h2>
              <ul className="space-y-2.5" data-id="element-4137" data-mp="oyr8m7u6t3gk">
                <li data-id="element-4138" data-mp="oxpm977q0ujj">
                  <Link to="/ua/ukrainskyi-stomatolog-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4139" data-mp="k1hbe60k3ni6">
                    🇺🇦 Ukrainian Dentist in London
                  </Link>
                </li>
                <li data-id="element-4140" data-mp="2mo676e0eov4d">
                  <Link to="/ua/implanty-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4141" data-mp="2monxyv4auh4w">
                    Dental Implants in London (UA)
                  </Link>
                </li>
                <li data-id="element-4142" data-mp="3je5e640wrlku">
                  <Link to="/ua/veneers-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4143" data-mp="3jclyaej5zcjl">
                    Veneers in London (UA)
                  </Link>
                </li>
                <li data-id="element-4144" data-mp="1typhvp831ucd">
                  <Link to="/ua/root-canal-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4145" data-mp="1ty5z66alz1xa">
                    Root Canal in London (UA)
                  </Link>
                </li>
                <li data-id="element-4146" data-mp="2lmabstk0cd0b">
                  <Link to="/ua/emergency-dentist-london" className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4147" data-mp="2llqrj66vxcj4">
                    Emergency Dentist in Angel (UA)
                  </Link>
                </li>
              </ul>
            </div>

            {/* Blog */}
            <div data-id="element-4148" data-mp="34d9z7qbuterh">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4149" data-mp="34crsfzrkfi5b">
                Blog
              </h2>
              <ul className="space-y-2.5" data-id="element-4150" data-mp="2zkguh2gdy6fe">
                <li data-id="element-4151" data-mp="2unqdmcwrb6sx">
                  <Link to={`/${lang}/blog`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4152" data-mp="2um6xqnf0ixro">
                    All Articles
                  </Link>
                </li>
                <li data-id="element-4153" data-mp="3un216i53teeg">
                  <Link to={`/${lang}/blog/dental-implants-cost-london`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4154" data-mp="3untufmb8b01k">
                    Скільки коштують імпланти в Лондоні?
                  </Link>
                </li>
                <li data-id="element-4155" data-mp="dfydh96tw8a8">
                  <Link to={`/${lang}/blog/nhs-vs-private-dentistry-uk`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4156" data-mp="dg87r8ywp1lq">
                    NHS vs Private Dentistry in the UK
                  </Link>
                </li>
                <li data-id="element-4157" data-mp="r8emcqmev0j2">
                  <Link to={`/${lang}/blog/dental-treatment-uk-without-insurance`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4158" data-mp="w5ermzbfrz94">
                    Лікування зубів у UK без страховки
                  </Link>
                </li>
                <li data-id="element-4159" data-mp="1j2bqn3a7fyo0">
                  <Link to={`/${lang}/blog/toothache-london-what-to-do`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4160" data-mp="1j2v8kjzuun21">
                    Зубний біль у Лондоні — що робити?
                  </Link>
                </li>
                <li data-id="element-4161" data-mp="1xs1a4em60pd3">
                  <Link to={`/${lang}/blog/veneers-london-everything-you-need-to-know`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4162" data-mp="1xs9l20yq9kln">
                    Вініри в Лондоні — що потрібно знати
                  </Link>
                </li>
                <li data-id="element-4163" data-mp="2gpubhch54r8d">
                  <Link to={`/${lang}/blog/how-to-choose-dentist-angel`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4164" data-mp="2go9gxmutt8ai">
                    Як обрати стоматолога в Angel
                  </Link>
                </li>
              </ul>
            </div>

            {/* Pricing */}
            <div data-id="element-4165" data-mp="a1bqbscjq21b">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4166" data-mp="a0sdgq1r63u5">
                Pricing
              </h2>
              <ul className="space-y-2.5" data-id="element-4167" data-mp="4zutc7x6mzq0">
                <li data-id="element-4168" data-mp="3e41ae8yfbc">
                  <Link to={`/${lang}/prices`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4169" data-mp="3xgibl4obhz">
                    Dental Fees – Transparent Private Prices
                  </Link>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div data-id="element-4170" data-mp="itdpzoesjeaj">
              <h2 className="text-2xl font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200" data-id="element-4171" data-mp="itvlujxjjqhx">
                Legal
              </h2>
              <ul className="space-y-2.5" data-id="element-4172" data-mp="38k8yc1gzardt">
                <li data-id="element-4173" data-mp="33juoqezqb9do">
                  <Link to={`/${lang}/privacy-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4174" data-mp="33jbgxr3sm1dd">
                    Privacy Policy
                  </Link>
                </li>
                <li data-id="element-4175" data-mp="1lm8510v3hxrh">
                  <Link to={`/${lang}/cookie-policy`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4176" data-mp="1lmrc1mj7j1qq">
                    Cookie Policy
                  </Link>
                </li>
                <li data-id="element-4177" data-mp="1gmv79l2or6a4">
                  <Link to={`/${lang}/patient-privacy-notice`} className="text-teal-600 hover:text-teal-800 hover:underline transition-colors" data-id="element-4178" data-mp="1gn4yfbzgvjhe">
                    Patient Privacy Notice
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Footer info */}
          <div className="mt-16 pt-8 border-t border-gray-200" data-id="element-4179" data-mp="xwds6jas0978">
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 text-gray-600" data-id="element-4180" data-mp="xvvkmqiny8k0">
              <div className="flex items-center gap-2" data-id="element-4181" data-mp="eavfkq55g717">
                <MapPin className="w-4 h-4 text-teal-600" data-id="element-4182" data-mp="a9s1o96nwl2m" />
                <span data-id="element-4183" data-mp="abcxs38mkc2l">
                  Dentico Clinic · 360–364 City Road · London EC1V 2PY
                </span>
              </div>
            </div>
            <div className="flex flex-wrap gap-3 mt-4" data-id="element-4184" data-mp="j8nalt13c99m">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" data-id="element-4185" data-mp="x9g3yafnoyb5">
                <Button size="sm" className="gap-2" data-id="element-4186" data-mp="x7d3ewgvnms6">
                  <Calendar className="w-4 h-4" data-id="element-4187" data-mp="t6t900noux9q" />
                  Book Online
                </Button>
              </a>
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-id="element-4188" data-mp="16yrc9uupxyxz">
                <Button variant="whatsapp" size="sm" className="gap-2" data-id="element-4189" data-mp="1217lxwkqxvpo">
                  <MessageCircle className="w-4 h-4" data-id="element-4190" data-mp="1gwxbg4p54qz5" />
                  WhatsApp
                </Button>
              </a>
              <a href="tel:+447345197820" data-id="element-4191" data-mp="1bzey8243bplc">
                <Button variant="outline" size="sm" className="gap-2" data-id="element-4192" data-mp="1bw9dez2hv9vf">
                  <Phone className="w-4 h-4" data-id="element-4193" data-mp="35gjm68d2lcbo" />
                  Request a Call
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}